import { useDefaultTaskGroupId } from './useDefaultTaskGroupId';

export function useIsDefaultTaskGroup(
  taskGroupId: string | null | undefined,
): boolean {
  const { defaultTaskGroupId } = useDefaultTaskGroupId();
  return taskGroupId != null && taskGroupId === defaultTaskGroupId;
}
